import { FormsV1 } from '@frontend/api-digital-forms';
import { DEFAULT_DFX_HTTP_OPTIONS } from '../../constants';

export const useGetKioskForms = (companyId: string) => {
  const { data, isLoading, isError } = FormsV1.Queries.useGetFormsKioskQuery({
    request: { companyId },
    options: { enabled: !!companyId },
    httpOptions: DEFAULT_DFX_HTTP_OPTIONS,
  });

  return {
    forms: data?.forms || [],
    isLoading,
    isError,
  };
};
